import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: 10,
    marginBottom:20,
    height: 40,
    boxSizing: 'border-box',
    gap: 12,
  },
  buttonBase: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '21px',
    borderRadius: 4,
    boxShadow: 'none',
    textTransform: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },
  cancelButton: {
    border: '1px solid #3F51B5',
    color: '#3F51B5',
    boxShadow: 'none',
    backgroundColor: '#fff',
    '&:hover': {
        boxShadow: 'none',
      backgroundColor: '#fff',
    },
  },
  saveButton: {
    color: '#fff',
    boxShadow: 'none',
    backgroundColor: '#3F51B5',
    '&:hover': {
        boxShadow: 'none',
      backgroundColor: '#3F51B5',
    },
  },
}));

export default useStyles;
